export class UnknownContextError extends Error {
    constructor(contextName: string) {
        const message = `Unable to access context \`${contextName}\`. Maybe you are not within the provider?`;
        
        super(message);
    }
}